module.exports = __webpack_public_path__ + "media/images/icon-accordion-edu-open-10e3e68cd895f63710054e4fab0077c7.svg";